<template>
	<!-- 确认信息框 -->
	<el-dialog
		width="700"
		title="部门信息确认"
		v-model="departmentOpen"
		:before-close="departmentClose"
	>
		<div class="info">
			<div class="infoItem">
				<div class="itemTitle">业绩所属部门：</div>
				<div class="itemContent">
					<div class="itemContentItem">{{ info.dept }}</div>
				</div>
			</div>
			<div class="infoItem">
				<div class="itemTitle">所属行政部门：</div>
				<div class="itemContent">
					<div class="itemContentItem" v-for="item in info.depts" :key="item.id">
						{{ item.name }}
					</div>
				</div>
			</div>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="departmentClose">不正确，我需要去联系客服中心</el-button>
				<el-popconfirm title="确定部门信息无误？" width="220" @confirm="departmentConfirm">
					<template #reference>
						<el-button type="primary">确认，部门信息无误</el-button>
					</template>
				</el-popconfirm>
			</div>
		</template>
	</el-dialog>
</template>
<script setup>
import { ref, getCurrentInstance } from 'vue'
import { confirmDepartmentInfo } from '@/api/common.js'
const { proxy } = getCurrentInstance()

const departmentOpen = ref(true) // 部门信息确认框
const props = defineProps({
	// 验证信息
	info: {
		type: Object,
		default: {}
	}
})
const emit = defineEmits(['confirm', 'close'])
const departmentClose = () => {
	emit('close')
}
const departmentConfirm = () => {
	confirmDepartmentInfo().then((res) => {
		if (res.code == 200) {
			proxy.$modal.msgSuccess(res.msg)
			emit('confirm')
		} else {
			proxy.$modal.msgError(res.msg)
		}
	})
}
</script>
<style lang="scss" scoped>
.info {
	display: flex;
	flex-direction: column;
	.infoItem {
		display: flex;
		margin-bottom: 20px;
		align-items: center;
		.itemTitle {
			width: 120px;
			font-weight: bold;
			text-align: right;
			margin-right: 10px;
		}
		.itemContent {
			flex: 1;
			display: flex;
			flex-direction: column;
			.itemContentItem {
				background: #f5f7fa;
				padding: 5px 10px;
				border-radius: 4px;
				margin-right: 10px;
				// margin-bottom: 10px;
			}
		}
	}
}
</style>
